import PlusCircleIcon from "../../assets/icons/plus-circle-icon.svg";
import PlusCircleDisabledIcon from "../../assets/icons/Plus-border-white.svg";
import ConditionIcon from "../../assets/icons/WorkflowAutomation/key.svg"
import TargetIcon from "../../assets/icons/target.svg"
import { ENUM_ACTION, ENUM_CONDITION } from "./AuotmationEnum";


const WorkFlowCard = ({
    workFlowData,
    formData,
    addNewWorkFlowCard
}) => {


    const addNewAutomation = (index) => {
        if (index === workFlowData.length - 1)
            addNewWorkFlowCard()
    }

    return (
        <>
            <span style={{ color: "#707070" }}>
                {`${formData.workFlowName} / ${formData.moduleName} / ${formData.subModuleName}`}
            </span>
            {workFlowData.map((item, index) => (
                <div
                    key={index}
                    className={`workflow-graph ${item.complete ? 'complete' : ''}`}
                    style={index === 0 ? { marginTop: "50px" } : { marginTop: "95px" }}
                >
                    {index !== 0 && <span className="vertical-flow-second" />}
                    <div className="flow-number">{index + 1}</div>
                    <span className="vertical-flow"></span>
                    <div className={index === workFlowData.length - 1 ? "flow-plus" : "flow-plus disabled"} onClick={() => { addNewAutomation(index) }}>

                        {workFlowData[index + 1] && workFlowData[index + 1].conditionType ? (
                            <>
                                <div className="condition-type">
                                    {workFlowData[index + 1].conditionType}
                                </div>
                            </>
                        ) : (
                            <>
                                <img
                                    src={index === workFlowData.length - 1 ? PlusCircleIcon : PlusCircleDisabledIcon}
                                    width={18}
                                    height={18}
                                    alt="Add Workflow"
                                />
                            </>
                        )}


                    </div>
                    {item.type == ENUM_CONDITION && (
                        <div className="flow-graph-content">
                            <div className="condition-title">
                                <img src={ConditionIcon} alt="condition" className="condition-icon" />&nbsp; &nbsp;{item.type}
                            </div>
                            <div className="condition-title text-elipsis "><strong>{`${formData.moduleName} | ${formData.subModuleName} | ${formData.formName}`}</strong></div>
                            <div className="condition-first">{item.triggerValue}</div>
                            <div className="d-flex align-items-center gap-5">
                                <div className="condition-compare">{item.rule}</div>
                                <div>{item.ruleValue}</div>
                            </div>
                        </div>
                    )}
                    {item.type == ENUM_ACTION && (
                        <div className="flow-graph-content">
                            <div className="condition-title">
                                <img src={TargetIcon} alt="condition" className="condition-icon" />&nbsp; &nbsp;{item.type}
                            </div>
                            <div className="condition-first">{item.moduleName}</div>
                            <div className="d-flex align-items-center gap-5">
                                <div className="condition-compare">{item.actionTitle}</div>
                                <div>{item.actionName}</div>
                            </div>
                        </div>
                    )}
                </div>
            ))}
        </>
    );
};

export default WorkFlowCard;
